import React, { useEffect, useState } from "react";
import {
  Card,
  Chip,
  Divider,
  Stack,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Rating,
  TextField,
  CircularProgress,
} from "@mui/material";
import formatWhatsAppNumber from "../../utils/formateWhatsappNumber";
import getFormattedDistance from "../../utils/getDistance";
import { types } from "../../utils/static";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import formatPhoneNumber from "../../utils/formatNumber";
import { Modal } from "react-bootstrap";
import {
  Call,
  Edit,
  WhatsApp,
  ExpandMore,
  Co2Sharp,
} from "@mui/icons-material";
import apis from "../../utils/apis";
import httpAction from "../../utils/httpAction";
import formatDuration from "../../utils/formatDuration";

const ContactCard = ({ item, contacts, setContacts, getContacts }) => {


  const [show, setShow] = useState(false);
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pendingWr, setPendingWr] = useState({});
  const initialValues = {
    type: "",
    detail: "",
    rating: 0,
    contactName: item?.name || "",
  };

  const validationSchema = Yup.object({
    type: Yup.string().trim().required("Please select the contact type"),
    detail: Yup.string().trim().required("Please provide the call detail"),
    rating: Yup.number().optional(),
    contactName: Yup.string().optional(),
  });

  const handleStartCall = async (type) => {
    const isPending = await getPendingWrapup();
    if (isPending) return;
    const data = {
      url: apis().startCall + "?id=" + item?._id,
      method: "POST",
    };

    const result = await httpAction(data);

    if (result?.status) {
      setPendingWr(item);
      const copyContact = [...contacts];
      const findedIndex = contacts.findIndex((cont) => cont._id === item?._id);
      copyContact.splice(findedIndex, 1, result?.contact);
      setContacts(copyContact);
      localStorage.setItem("lastCall", item);
      if (type === "whatsapp") {
        window.open(`https://wa.me/${formatWhatsAppNumber(item?.number)}`);
      } else {
        window.open(`tel:${formatPhoneNumber(item?.number)}`);
      }
    }
  };

  const endCall = async (values) => {
    const data = {
      url: apis().endCall + "?id=" + pendingWr?._id,
      method: "POST",
      body: { ...values, clientName: values.contactName },
    };
    const result = await httpAction(data);
    if (result?.status) {
      await getContacts();
      setPendingWr({});
      setShow(false); // Close the modal
    }
  };

  // Inside the component, where you use formatDistanceToNow

  const getHis = async () => {
    const data = {
      url: apis().getSingleContactHis + "?id=" + item?._id,
    };

    setLoading(true);
    const result = await httpAction(data);
    setLoading(false);

    if (result?.status) {
      setHistory(result?.history?.callHistory);
    }
  };

  async function getPendingWrapup() {
    const id = localStorage.getItem("userId");
    const data = {
      url: apis().getPendingWrapup + `?id=${id}`,
    };
    const result = await httpAction(data);
    if (result?.status && result?.contact?._id) {
  
      setPendingWr(result?.contact);
      setShow(true);
    }
    return result?.status && result?.contact?._id ? true : false;
  }

  return (
    <div className="col-md-6">
      <Card sx={{ padding: "0.8rem" }} variant="outlined">
        <Modal show={show} onHide={() => setShow(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Wrap Up for: {pendingWr?.number}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={endCall} // Pass form values to endCall
            >
              {({
                handleBlur,
                handleChange,
                values,
                errors,
                touched,
                setFieldValue,
              }) => (
                <Form>
                  <Stack spacing={2}>
                    <span style={{ color: "gray", fontSize: "14px" }}>
                      Select Client Type
                    </span>
                    <div style={{ overflowX: "auto" }}>
                      <Stack size="small" direction="row" spacing={2}>
                        {types
                          .filter((item) => item !== "all")
                          .map((item, index) => (
                            <Chip
                              onClick={() => setFieldValue("type", item)}
                              color={
                                values.type === item ? "success" : "default"
                              }
                              label={item}
                              key={index}
                            />
                          ))}
                      </Stack>
                    </div>
                    {errors.type && touched.type && (
                      <div style={{ color: "red", fontSize: "12px" }}>
                        {errors.type}
                      </div>
                    )}
                    <Divider />
                    <span style={{ color: "gray", fontSize: "14px" }}>
                      Enter call detail
                    </span>

                    <textarea
                      onChange={handleChange}
                      onBlur={handleBlur}
                      name="detail"
                      className="form-control"
                      rows="5"
                      value={values.detail}
                    ></textarea>
                    {errors.detail && touched.detail && (
                      <div style={{ color: "red", fontSize: "12px" }}>
                        {errors.detail}
                      </div>
                    )}
                    <Divider />
                    <span style={{ color: "gray", fontSize: "14px" }}>
                      Client name (optional)
                    </span>
                    <TextField
                      size="small"
                      onChange={handleChange}
                      fullWidth
                      label="Enter client name"
                      name="contactName"
                      autoComplete="off"
                      value={values.contactName}
                    />
                    <Divider />
                    <span style={{ color: "gray", fontSize: "14px" }}>
                      Give rating (optional)
                    </span>
                    <Rating
                      onChange={handleChange}
                      name="rating"
                      value={values.rating}
                    />
                    <Divider />
                    <Button type="submit" variant="contained" fullWidth>
                      Save Detail
                    </Button>
                  </Stack>
                </Form>
              )}
            </Formik>
          </Modal.Body>
        </Modal>
        <Stack spacing={1}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Chip
              label={item?.type}
              size="small"
              sx={{ textTransform: "capitalize" }}
              color={item?.type === "not interested" ? "error" : "default"}
            />
            <Chip
              label={item?.wrapupPending ? "Pending" : "Wrapped Up"}
              size="small"
              color={item?.wrapupPending ? "warning" : "success"}
            />
          </div>
          <Divider />
          <strong className="text-capitalize">{item?.name || "unknown"}</strong>
          <Rating size="small" readOnly defaultValue={item?.rating} />
          <span>{formatPhoneNumber(item?.number)}</span>
          <Divider />
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <span style={{ fontSize: "14px" }}>Last Dail</span>
            <Chip
              color="secondary"
              label={getFormattedDistance(item?.lastDailDate) + " " + "ago"}
              size="small"
            />
          </div>
          <Divider />
          <span style={{ fontSize: "12px", color: "gray" }}>
            Last Call Note
          </span>
          <span style={{ fontSize: "14px" }}>
            {item?.callHistory[item?.callHistory?.length - 1]?.detail}
          </span>
          <Divider />
          <div>
            <Stack direction="row" spacing={1}>
              <Button
                disabled={item?.wrapupPending}
                onClick={handleStartCall}
                size="small"
                sx={{ fontSize: "14px" }}
                fullWidth
                variant="contained"
                endIcon={<Call />}
              >
                Call
              </Button>
              <Button
                onClick={() => handleStartCall("whatsapp")}
                disabled={item?.wrapupPending}
                size="small"
                sx={{ fontSize: "14px" }}
                fullWidth
                variant="contained"
                color="success"
                endIcon={<WhatsApp />}
              >
                Whats App
              </Button>
            </Stack>
          </div>
          <Button
            disabled={!item.wrapupPending}
            onClick={() => {
              // const lastCall = JSON.parse(localStorage.getItem("lastCall"));
              setPendingWr(item);
              setShow(true);
            }}
            endIcon={<Edit />}
            color="secondary"
            variant="outlined"
            size="small"
          >
            Wrap Up
          </Button>
          <Divider />
          <Stack direction="row" spacing={2}>
            <Chip
              sx={{ textTransform: "capitalize" }}
              label={item?.source}
              size="small"
            />
            <Chip
              sx={{ textTransform: "capitalize" }}
              label={item?.project}
              size="small"
            />
          </Stack>
          <Divider />
          <div className="user_call_his_detail_accordion">
            <Accordion>
              <AccordionSummary onClick={getHis} expandIcon={<ExpandMore />}>
                Call History
              </AccordionSummary>
              {loading ? (
                <div
                  style={{
                    height: "120px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CircularProgress />
                </div>
              ) : (
                history.map((his, index) => (
                  <AccordionDetails key={index}>
                    <div className="user_call_his_main">
                      <Stack spacing={1}>
                        <div className="d-flex justify-content-between">
                          <Chip label="Dialed" size="small" />
                          <Chip
                            color="warning"
                            label={
                              getFormattedDistance(his?.callStartAt) +
                              " " +
                              "ago"
                            }
                            size="small"
                          />
                        </div>
                        <Divider />
                        <div className="d-flex justify-content-between">
                          <Chip label="Call Duration" size="small" />
                          <Chip
                            color="default"
                            label={formatDuration(his?.callDuration)}
                            size="small"
                          />
                        </div>
                        <Divider />
                        <span style={{ color: "gray", fontSize: "14px" }}>
                          Note
                        </span>
                        <textarea
                          readOnly
                          value={his?.detail}
                          rows={5}
                          className="user_call_his_detail"
                        />
                      </Stack>
                    </div>
                  </AccordionDetails>
                ))
              )}
            </Accordion>
          </div>
        </Stack>
      </Card>
    </div>
  );
};

export default ContactCard;
